import { useEffect, useRef } from 'react';
import type { NavigateFunction } from 'react-router';
import { useNavigate } from 'react-router';

export const useNavigateRef = () => {
  const navigate = useNavigate();
  const navRef = useRef<NavigateFunction>(navigate);

  useEffect(() => {
    navRef.current = navigate;
  }, [navigate]);

  return navRef;
};
